"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strToFunc = function (funCode) {
    return (new Function("return " + funCode))();
};
exports.funcToStr = function (func) {
    return typeof func === "function" ? func.toString() : "";
};
exports.onmessage = function (e) {
    var msgData = e.data;
    var msgType = msgData.type;
    var elmer = self["elmer"];
    var dataType = Object.prototype.toString.call(msgData.data);
    var tmpFn;
    try {
        if (msgType === "InitObject") {
            self[msgData.globalName] = self["workerDataToObject"](msgData.data);
            elmer.sendMsg({
                id: msgData.id,
                message: "success",
                statusCode: 200,
                type: msgType
            });
            return;
        }
        else if (msgType === "InitFunction") {
            self[msgData.globalName] = self["strToFunc"](msgData.data);
            elmer.sendMsg({
                id: msgData.id,
                message: "success",
                statusCode: 200,
                type: msgType
            });
            return;
        }
        else if (msgType === "CallObjMethod" || msgType === "CallMethod") {
            var objKey = msgData.obj;
            var callbackName = msgData.method;
            var selfFunc = void 0;
            if (msgType === "CallObjMethod") {
                var runCode = "var fn = " + objKey + "." + callbackName + ";\r\n";
                if (dataType === "[object Array]") {
                    runCode += "return fn.apply(" + objKey + ", argv);\r\n";
                }
                else {
                    runCode += "return fn(argv);\r\n";
                }
                selfFunc = new Function("argv", runCode);
            }
            else {
                if (dataType === "[object Array]") {
                    selfFunc = new Function('argv', "return " + callbackName + ".apply(self, argv);");
                }
                else {
                    selfFunc = new Function('argv', "return " + callbackName + "(argv);");
                }
            }
            if (typeof selfFunc === "function") {
                var callResult = selfFunc(msgData.data);
                elmer.sendMsg({
                    data: callResult,
                    id: msgData.id,
                    message: "",
                    statusCode: 200,
                    type: msgType
                });
            }
            else {
                elmer.sendMsg({
                    id: msgData.id,
                    message: tmpFn === undefined ? "The calling method is not defined" : "The specified object is not a function",
                    type: "CallObjMethod"
                });
            }
            return;
        }
    }
    catch (e) {
        console.error(e);
        elmer.sendMsg({
            data: undefined,
            error: e,
            id: msgData.id,
            message: e.message,
            statusCode: 500,
            type: msgType
        });
    }
};
exports.objectToWorkerData = function (obj) {
    var result = {
        data: {},
        funcData: {}
    };
    if (typeof obj === "object") {
        for (var key in obj) {
            if (typeof obj[key] === "function") {
                result.funcData[key] = obj[key].toString();
            }
            else {
                result.data[key] = obj[key];
            }
        }
    }
    return result;
};
exports.objectToWorkerCode = function (obj, className) {
    var innerObjKey = className + (new Date()).format("YYYYMMDDHisms");
    var result = "(function(){\r\n";
    result += "    function " + className + "(){};\r\n";
    if (typeof obj === "object") {
        var _loop_1 = function (key) {
            var tmpValue = obj[key];
            var tmpType = Object.prototype.toString.call(tmpValue);
            if (typeof tmpValue === "function") {
                var code = tmpValue.toString();
                result += "    " + className + ".prototype." + key + " = " + code + ";\r\n";
            }
            else if (tmpType === "[object RegExp]") {
                var regCode = tmpValue.toString();
                result += "    " + className + ".prototype." + key + " = " + regCode + ";\r\n";
            }
            else if (tmpType === "[object Array]") {
                var tmpResult_1 = [];
                tmpValue.map(function (tmpItem) {
                    if (Object.prototype.toString.call(tmpItem) === "[object RegExp]") {
                        tmpResult_1.push(tmpItem.toString());
                    }
                    else {
                        tmpResult_1.push(JSON.stringify(tmpItem));
                    }
                });
                result += "    " + className + ".prototype." + key + " = [" + tmpResult_1.join(",") + "];\r\n";
            }
            else {
                result += "    " + className + ".prototype." + key + " = " + JSON.stringify(obj[key]) + ";\r\n";
            }
        };
        for (var key in obj) {
            _loop_1(key);
        }
    }
    result += "    var " + innerObjKey + " = new " + className + "();\r\n";
    result += "    return " + innerObjKey + ";\r\n";
    result += "})();\r\n";
    result = result.replace(/\sthis\./g, [" ", innerObjKey, "."].join(""))
        .replace(/\!this\./g, ["!", innerObjKey, "."].join(""))
        .replace(/([\(\&\|\=\;])this\./g, ["$1", innerObjKey, "."].join(""));
    return result;
};
exports.classToWorkerCode = function (func) {
    var coreCode = func.toString().replace(/^function\s[a-z0-9\_]{1,}\s*\(/i, "");
    var defineName = func.name;
    var code = "(function(){\r\n";
    code += "    function " + defineName + "(" + coreCode + ";\r\n";
    Object.keys(func).map(function (funcKey) {
        var fCode = func[funcKey];
        if (typeof fCode === "object") {
            fCode = JSON.stringify(fCode, null, 4);
        }
        else if (typeof fCode === "function") {
            fCode = fCode.toString();
        }
        code += "    " + defineName + "." + funcKey + " = " + fCode + ";\r\n";
    });
    code += "    return " + defineName + ";\r\n";
    code += "})();";
    return code;
};
exports.workerDataToObject = function (eventData) {
    var result = {};
    if (eventData) {
        if (eventData.data) {
            for (var key in eventData.data) {
                result[key] = eventData.data[key];
            }
        }
        if (eventData.funcData) {
            for (var key in eventData.funcData) {
                result[key] = self["strToFunc"](eventData.funcData[key]);
            }
        }
    }
    return result;
};
exports.__spreadArrays = function () {
    var il = arguments.length;
    var s = 0;
    for (var z = 0; z < il; z++) {
        s += arguments[z].length;
    }
    var r = Array(s);
    for (var k = 0, i = 0; i < il; i++) {
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
};
